import { css } from '@emotion/core';
import { onMobileDevice } from './mediaQueries';


export const GLOBAL_FONTS = css`
  h1 { 
    font-size: 26px;
    font-weight: normal;
  }
  
  h2 { 
    font-size: 16px;
    font-weight: bold;
  }
  
  h3 { 
    font-size: 13px;
    font-weight: bold;
  }
  
  h4 { 
    font-size: 12px;
    font-weight: bold;
  }
  
  h5 { 
    font-size: 12px;
  }
  
  body { 
    font-size: 12px;
    font-family: 'Arial', 'Helvetica', sans-serif, -apple-system, BlinkMacSystemFont ;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  * { 
    font-family: 'Arial', 'Helvetica', sans-serif, -apple-system, BlinkMacSystemFont ;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button {
    font-size: 16px;
  }

  ${onMobileDevice} { 
    h1 { 
      font-size: 18px;
    }
  }
`;
